import { useTheme } from "@material-ui/core";
import Grid from "@material-ui/core/Grid";
import Link from "@material-ui/core/Link";
import Paper from "@material-ui/core/Paper";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import SortableTable from "../../Components/SortableTable";
import Title from "../../Components/Title";
import { showPopupSnackbar } from "../../redux/actions/snackbarActions";
import { formatTimeWithTZOffset, getToken } from "../../Utils/Common";
import EnvSettings from "../../Utils/EnvSettings";
import { useStyles } from "../../Utils/Styles";

const server = EnvSettings.server;

function formatTransportationData(data) {
  var arr = [];
  data.forEach((element) => {
    arr.push({
      id: element.id,
      startTime: formatTimeWithTZOffset(element.startTime),
      endTime: formatTimeWithTZOffset(element.endTime),
      description: element.description,
      serialNumber: element.Device.serialNumber,
      deviceName: element.Device.deviceName,
      alerts: element.Alerts.length,
    });
  });
  return arr;
}

export default function RecentTransports() {
  const [recentTransports, setRecentTransports] = useState();
  const classes = useStyles();
  const theme = useTheme();
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const history = useHistory();

  let getRecentTransports = () => {
    const requestOptions = {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ token: getToken() }),
    };
    fetch(server + "/get_transportation_list", requestOptions)
      .then((res) => res.json())
      .then((result) => {
        if (process.env.NODE_ENV !== "production") {
          console.log(result);
        }
        if (result.error) {
          dispatch(showPopupSnackbar(result));
        } else {
          setRecentTransports(formatTransportationData(result.transports));
        }
      });
  };

  let setRowStyle = (data) => {
    if (data.alerts > 0) {
      return {
        backgroundColor: theme.palette.warning.light,
        cursor: "pointer",
      };
    }
    return { cursor: "pointer" };
  };

  let handleRowClick = (data) => {
    history.push("/transports/" + data);
  };

  useEffect(getRecentTransports, []);

  return (
    <Grid item xs={12}>
      <Paper className={classes.paper}>
        <Title>{t("transportList.header")}</Title>
        {recentTransports ? (
          <SortableTable
            data={{
              headCells: [
                {
                  id: "startTime",
                  numeric: false,
                  disablePadding: true,
                  label: t("transportList.started"),
                },
                {
                  id: "endTime",
                  numeric: false,
                  disablePadding: false,
                  label: t("transportList.ended"),
                },
                {
                  id: "description",
                  numeric: false,
                  disablePadding: false,
                  label: t("transportList.description"),
                },
                {
                  id: "serialNumber",
                  numeric: false,
                  disablePadding: false,
                  label: t("transportList.serial"),
                },
                {
                  id: "deviceName",
                  numeric: false,
                  disablePadding: false,
                  label: t("transportList.name"),
                },
                {
                  id: "alerts",
                  numeric: false,
                  disablePadding: false,
                  label: t("transportList.alerts"),
                },
              ],
              defaultSortRow: "startTime",
              handleRowClick: handleRowClick,
              getRowStyle: setRowStyle,
              tableData: recentTransports,
              rowsPerPage: 5,
            }}
          />
        ) : undefined}
        {/*<TransportList data={recentTransports} /> */}
        <div className={classes.seeMore}>
          <Link
            color="primary"
            href="#"
            onClick={(e) => {
              e.preventDefault();
              history.push("/transports");
            }}
          >
            {t("transportList.seeMore")}
          </Link>
        </div>
      </Paper>
    </Grid>
  );
}
